// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__ZOZ8K","container":"styles_container__8VCOx","iconButton":"styles_iconButton__aElwM","second":"styles_second__U9MYb"};